/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
import type User from 'flarum/common/models/User';
import type Article from 'flarum/orell-articles/models/Article';

export default class Note extends Model {
	text() {
		return Model.attribute<string>('text').call(this);
	}

	user() {
		return Model.hasOne<User>('user').call(this);
	}

	article() {
		return Model.hasOne<Article>('article').call(this);
	}
}
